
export default function UserProfileNavService(gettext) {

    'ngInject';

    var module = {
        "id": "profile",
        "name": gettext("Profile"),
        "sref": "users",
        "hide": true,
        "priority": 9,
        "items": [
            {
                "name": gettext("Edit Profile"),
                "sref": "users.profile",
                "group": "Profile"
            },
            {
                "name": gettext("Subscriptions"),
                "sref": "users.subscriptions",
                "group": "Profile"
            }
        ],
        groups: [
            {
                id: "Profile",
                name: gettext("Profile")
            }
        ]
    };

    this.getModule = function () {
        return module;
    };

}
